(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/spelpaus-react/assets/react/pages/svs-suspension/svs-suspension-helper.js') >= 0) return;  svs.modules.push('/modules/spelpaus-react/assets/react/pages/svs-suspension/svs-suspension-helper.js');

'use strict';

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
const logger = svs.spelpaus.logger;
const {
  SUSPENSION_PERIOD,
  SUSPENSION_PRODUCT_ID,
  CALL_STATUS
} = svs.spelpaus.constants;
const {
  postNewSuspensionAsync
} = svs.spelpaus.pages.svsSuspension.SvsSuspensionService;
const {
  showSetSuspensionConfirmationDialogAsync,
  showSetSuspensionSuccessDialog,
  showSetSuspensionErrorDialogAsync
} = svs.spelpaus.pages.svsSuspension.SvsSuspensionDialog;

const trackPausText = {
  SUCCESS: 'Activated',
  FAILED: 'Cancelled',
  SUCESS_CS: 'Activated customerservice',
  FAILED_CS: 'Cancelled customerservice'
};
const getProductText = function (product) {
  let type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  let initialCapital = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
  let LongName = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;
  switch (product) {
    case SUSPENSION_PRODUCT_ID.ALL:
      return initialCapital ? 'Alla spel' : 'alla spel';
    case SUSPENSION_PRODUCT_ID.QUICKGAMES:
      if ((type === null || type === void 0 ? void 0 : type.toLowerCase()) === 'acute') {
        return 'Spelpaus24';
      }
      return LongName ? 'Lotter och KenoXpress' : 'Lotter';
    case SUSPENSION_PRODUCT_ID.VEGAS:
      return 'Vegas';
    default:
      return 'aktiv';
  }
};
const getSuspensionTypeText = (period, terminationPeriod) => {
  const periodInternal = period > 0 ? period : terminationPeriod || 0;
  switch (periodInternal) {
    case 3:
      return '3 månader';
    case 6:
      return '6 månader';
    case 12:
      return '1 år';
    case 36:
      return '3 år';
    default:
      return '';
  }
};
const getActiveValideToDate = suspension => {
  const validToText = suspension.validTo ? svs.utils.date.FormatTime('d/M, yyyy', suspension.validTo) : svs.utils.date.FormatTime('d/M, yyyy', suspension.terminable);
  return validToText;
};
const getActiveValideToDateTime = validTo => {
  const validToText = svs.utils.date.FormatTime('d/M, yyyy, HH:mm', validTo);
  return validToText;
};
const getAvailableSuspensionPeriods = (activeSuspensions, suspensionProduct) => {
  if (suspensionProduct === '0') {
    return [];
  }
  const availableSuspensionPeriods = [];
  const hasActiveSuspensionOnThis = activeSuspensions && activeSuspensions.find(s => s.product === suspensionProduct);
  logger.debug('activeSuspensions ', activeSuspensions);
  logger.debug('suspensionProduct ', suspensionProduct);
  logger.debug('hasActiveSuspensionOnThis ', hasActiveSuspensionOnThis);
  const periodInternal = (hasActiveSuspensionOnThis === null || hasActiveSuspensionOnThis === void 0 ? void 0 : hasActiveSuspensionOnThis.period) > 0 ? hasActiveSuspensionOnThis === null || hasActiveSuspensionOnThis === void 0 ? void 0 : hasActiveSuspensionOnThis.period : (hasActiveSuspensionOnThis === null || hasActiveSuspensionOnThis === void 0 ? void 0 : hasActiveSuspensionOnThis.terminationPeriod) || 0;
  SUSPENSION_PERIOD.forEach(p => {
    const disabled = hasActiveSuspensionOnThis && (p.month < periodInternal || p.month === periodInternal && dateFns.format(dateFns.parseISO(hasActiveSuspensionOnThis.validFrom), 'yyyyMMdd') === dateFns.format(Date.now(), 'yyyyMMdd'));
    availableSuspensionPeriods.push(_objectSpread(_objectSpread({}, p), {}, {
      disabled
    }));
  });
  logger.debug('availableSuspensionPeriods', availableSuspensionPeriods);
  return availableSuspensionPeriods;
};

const contSetNewSuspensionAsyncAsync = async (suspension, postToken) => {
  logger.debug('contSetNewSuspensionAsyncAsync suspension, postToken:', suspension, postToken);
  try {
    const {
      status,
      suspensions,
      error,
      xhr
    } = await postNewSuspensionAsync(suspension, postToken);
    logger.debug('contSetNewSuspensionAsyncAsync after jupiter call status, suspensions, error, xhr:', status, suspensions, error, xhr);
    if (status === CALL_STATUS.SUCCESS) {
      if (svs.core.userSession.getLoginType() === 'BANKID') {
        logger.debug('Suspension request with bankid done');
      } else if (svs.core.userSession.getLoginType() === 'FREJA_EID') {
        logger.debug('Suspension request with Freja eID done');
      }
      const accountBalance = await new Promise(resolve => {
        svs.components.account_balance.get(accountBalance => {
          resolve(accountBalance);
        });
      });
      svs.spelpaus.logger.debug('accountBalance: ', accountBalance);
      showSetSuspensionSuccessDialog(suspension, accountBalance);
      return {
        status,
        suspensions
      };
    }
    logger.debug('No response status === success. status, error: ', status, error);
    showSetSuspensionErrorDialogAsync(error);
    return {
      status,
      error
    };
  } catch (error) {
    logger.debug('***** messageFail(), catch error: ', error);
    return {
      status: CALL_STATUS.ERROR,
      error
    };
  }
};

const trackPaus = (analyticsData, actionText) => ({
  category: 'Spelpaus',
  action: actionText,
  opt_label: analyticsData
});

const errorKS = error => {
  logger.debug('Suspension request for customer service canceled, error: ', error);
  return {
    status: CALL_STATUS.CANCEL,
    error
  };
};

const setNewSuspensionAsync = async (product, period) => {
  logger.debug('setNewSuspensionAsync product, periodMonth:', product, period);
  const suspension = {
    product
  };
  if (period >= 12) {
    suspension.type = 'timeOngoing';
    suspension.termination = period;
  } else {
    suspension.type = 'timeGiven';
    suspension.period = period;
  }
  logger.debug('setNewSuspensionAsync suspension:', suspension);
  const analyticsData = "".concat(product, ":").concat(period);
  if (svs.core.userSession.hasRole(svs.core.userSession.roles.CUSTOMERSERVICE)) {
    logger.debug('Suspension request for customer service started');
    try {
      await showSetSuspensionConfirmationDialogAsync(suspension);
      logger.debug('Suspension Confirmation Dialog fullfilled');
    } catch (error) {
      svs.components.analytics.trackEvent(trackPaus(analyticsData, trackPausText.FAILED_CS));
      logger.debug('Suspension request canceled, error: ', error);
      return {
        status: CALL_STATUS.CANCEL,
        error
      };
    }
    try {
      const response = await contSetNewSuspensionAsyncAsync(suspension);
      if (response.status === 'error') {
        return errorKS(response.error);
      }
      svs.components.analytics.trackEvent(trackPaus(analyticsData, trackPausText.SUCESS_CS));
      return response;
    } catch (error) {
      return errorKS(error);
    }
  } else {
    try {
      let idResponse;
      if (svs.core.userSession.getLoginType() === 'BANKID') {
        logger.debug('Suspension request with bankid started');
        idResponse = await new Promise(resolve => {
          svs.app.bankid.verifySuspensionRequest(undefined, postToken => {
            resolve(postToken);
          }, undefined, void 0, trackPaus(analyticsData, trackPausText.SUCCESS), trackPaus(analyticsData, trackPausText.FAILED));
        });
      } else if (svs.core.userSession.getLoginType() === 'FREJA_EID') {
        logger.debug('Suspension request with Freja eID started');
        idResponse = await new Promise(resolve => {
          svs.app.frejaeid.verifySuspensionRequest(undefined, postToken => {
            resolve(postToken);
          }, undefined, void 0, trackPaus(analyticsData, trackPausText.SUCCESS), trackPaus(analyticsData, trackPausText.FAILED));
        });
      } else {
        logger.varning('Suspension verify could not be done, Unknowed Login type.');
        return {
          status: CALL_STATUS.ERROR,
          error: new TypeError('Unknowed Login type.')
        };
      }
      logger.debug('Suspension verify with electronic ID fullfilled, response: ', idResponse);
      try {
        const response = await contSetNewSuspensionAsyncAsync(suspension, idResponse.postToken);
        logger.debug('Suspension request with electronic ID done');
        return response;
      } catch (error) {
        logger.debug('Suspension request with electronic ID jupiter error: ', error);
        return {
          status: CALL_STATUS.ERROR,
          error
        };
      }
    } catch (error) {
      logger.debug('Suspension verify with electronic ID, error: ', error);
      return {
        status: CALL_STATUS.ERROR,
        error
      };
    }
  }
};
svs.spelpaus.pages.svsSuspension.SvsSuspensionHelper = {
  getProductText,
  getSuspensionTypeText,
  getActiveValideToDate,
  getActiveValideToDateTime,
  getAvailableSuspensionPeriods,
  setNewSuspensionAsync
};

 })(window);